import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { clone as t } from "../lang.js";
import { assumeNonNull as s } from "../maybe.js";
import { OriginIdNum as e } from "./PropertyOrigin.js";

var r = /*#__PURE__*/function () {
  function r() {
    _classCallCheck(this, r);

    this._propertyOriginMap = new Map(), this._originStores = new Array(e), this._values = new Map();
  }

  _createClass(r, [{
    key: "clone",
    value: function clone(s) {
      var _this = this;

      var i = new r(),
          o = this._originStores[0];
      o && o.forEach(function (s, e) {
        i.set(e, t(s), 0);
      });

      var _loop = function _loop(_r5) {
        var e = _this._originStores[_r5];
        e && e.forEach(function (e, o) {
          s && s.has(o) || i.set(o, t(e), _r5);
        });
      };

      for (var _r5 = 2; _r5 < e; _r5++) {
        _loop(_r5);
      }

      return i;
    }
  }, {
    key: "get",
    value: function get(t, s) {
      var e = void 0 === s ? this._values : this._originStores[s];
      return e ? e.get(t) : void 0;
    }
  }, {
    key: "keys",
    value: function keys(t) {
      var s = null == t ? this._values : this._originStores[t];
      return s ? _toConsumableArray(s.keys()) : [];
    }
  }, {
    key: "set",
    value: function set(t, e) {
      var _r2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;

      var i = this._originStores[_r2];

      if (i || (i = new Map(), this._originStores[_r2] = i), i.set(t, e), !this._values.has(t) || s(this._propertyOriginMap.get(t)) <= _r2) {
        var _s = this._values.get(t);

        return this._values.set(t, e), this._propertyOriginMap.set(t, _r2), _s !== e;
      }

      return !1;
    }
  }, {
    key: "delete",
    value: function _delete(t) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
      var e = this._originStores[s];
      if (!e) return;

      var _r3 = e.get(t);

      if (e.delete(t), this._values.has(t) && this._propertyOriginMap.get(t) === s) {
        this._values.delete(t);

        for (var _e = s - 1; _e >= 0; _e--) {
          var _s2 = this._originStores[_e];

          if (_s2 && _s2.has(t)) {
            this._values.set(t, _s2.get(t)), this._propertyOriginMap.set(t, _e);
            break;
          }
        }
      }

      return _r3;
    }
  }, {
    key: "has",
    value: function has(t, s) {
      var e = void 0 === s ? this._values : this._originStores[s];
      return !!e && e.has(t);
    }
  }, {
    key: "revert",
    value: function revert(t, s) {
      for (; s > 0 && !this.has(t, s);) {
        --s;
      }

      var e = this._originStores[s],
          _r4 = e && e.get(t),
          i = this._values.get(t);

      return this._values.set(t, _r4), this._propertyOriginMap.set(t, s), i !== _r4;
    }
  }, {
    key: "originOf",
    value: function originOf(t) {
      return this._propertyOriginMap.get(t) || 0;
    }
  }, {
    key: "forEach",
    value: function forEach(t) {
      this._values.forEach(t);
    }
  }]);

  return r;
}();

export { r as default };